<template>
  <mg-dialog
    :show.sync="dialogVisible"
    title="收货地址"
    size="middle"
    class="address-list-dialog"
    :class="{ 'address-list-dialog__h5': isH5 }"
    :append-to-body="true"
    @cancel="cancel"
  >
    <el-button
      class="add-btn"
      :disabled="addressList && addressList.length >= 5"
      @click="handleAddAddress"
    >
      添加地址
    </el-button>
    <div class="address-list" v-if="addressList && addressList.length">
      <div
        class="address-item"
        :class="{ 'address-item__selected': item.id === selectedAddress.id }"
        v-for="(item, index) in addressList"
        :key="item.id"
        @click="handleSelectAddress(item)"
      >
        <div class="name-area">
          <span class="name">{{ item.name }}</span>
          <span class="phone">{{ item.mobile }}</span>
        </div>
        <div class="address-area">
          <div class="address">
            {{ item.province + item.city + item.district + item.address }}
          </div>
          <div class="handle-box">
            <img
              src="../../../assets/images/address/edit_icon.png"
              alt=""
              @click.stop="handleEdit(item, index)"
            />
            <img
              src="../../../assets/images/address/delete_icon.png"
              alt=""
              @click.stop="handleDelete(item, index)"
            />
          </div>
        </div>
        <div class="default-tag" v-if="item.is_default">默认地址</div>
      </div>
    </div>
    <el-empty
      style="flex: 1"
      v-else
      description="暂无收货地址"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
    <div class="tips">
      <p>收货地址一经提交不可修改，请谨慎填写！</p>
      <p>如果需要更改收货信息或产生争议，请联系课程老师。</p>
    </div>
    <div class="footer">
      <el-button @click="close" class="el-button__cancel" size="medium"
        >取 消</el-button
      >
      <el-button type="primary" size="medium" @click="confirmSelect"
        >提 交</el-button
      >
    </div>
    <edit
      ref="edit"
      :addressInfo="editAddressInfo"
      @cancel="cancelEdit"
      @success="successEdit"
    ></edit>
  </mg-dialog>
</template>

<script>
import MgDialog from "../mg-dialog/Index.vue";
import {
  getAddressList,
  deleteAddress,
} from "@saas/service-api/src/address/index.js";
import Edit from "./Edit.vue";
import { isH5, isMobile } from "@saas/components/src";

export default {
  props: {},
  data() {
    return {
      dialogVisible: false,
      timer: null,
      addressList: [],
      selectedAddress: {},
      editAddressInfo: {},
      isH5: isH5(),
    };
  },
  watch: {},
  methods: {
    close() {
      this.dialogVisible = false;
    },
    open() {
      this.dialogVisible = true;
      this.getAddressList();
    },
    cancel() {},
    confirmSelect() {
      this.$emit("confirm", this.selectedAddress);
    },

    handleSelectAddress(address) {
      this.selectedAddress = address;
    },
    handleDelete(address, index) {
      this.$confirm("是否确认删除此地址信息？", "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
        deleteAddress({ id: address.id }).then((res) => {
          if (res.code === 1) {
            this.$message.success("删除成功");
            this.addressList.splice(index, 1);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    getAddressList() {
      getAddressList().then((res) => {
        if (res.code === 1) {
          this.addressList = res.data;
          this.selectedAddress = this.addressList[0];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleEdit(address, index) {
      this.editAddressInfo = address;
      this.$refs.edit.open();
      this.dialogVisible = false;
    },
    // 取消编辑/新增
    cancelEdit() {
      this.editAddressInfo = {};
      this.dialogVisible = true;
    },
    successEdit() {
      this.getAddressList();
      this.editAddressInfo = {};
      this.dialogVisible = true;
    },
    // 新增地址
    handleAddAddress() {
      this.editAddressInfo = {};
      this.$refs.edit.open();
      this.dialogVisible = false;
    },
  },
  components: {
    MgDialog,
    Edit,
  },
};
</script>

<style scoped lang="scss">
.address-list-dialog ::v-deep {
  .el-dialog {
    --address-list-card-bg: transparent;
    --address-list-border: #e5e6e8;
    --address-list-primary: #0d1400;
    --address-list-muted: #747573;
    --address-list-brand: var(--mg-brand-primary, #00c89d);
    --address-list-brand-soft: rgba(0, 200, 157, 0.1);
    width: 580px;
  }
  .el-dialog__body {
    padding: 0 20px 25px 20px !important;
  }
  .el-form {
    margin-top: 20px;
  }
  .footer {
    text-align: right;
  }
  .el-dialog__header {
    padding-top: 22px !important;
  }
  .add-btn {
    background: unset;
    width: 80px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid var(--address-list-brand);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--address-list-brand);
    font-weight: 400;
    font-size: 14px;
    color: var(--address-list-brand);
    &.is-disabled {
      cursor: not-allowed;
      color: var(--address-list-muted);
      border-color: var(--address-list-muted);
    }
  }
}
.address-list-dialog__h5 ::v-deep {
  .el-dialog {
    width: 9.3333rem;
    height: 80%;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
  .el-dialog__body {
    padding: 0 0.2667rem 0.3333rem 0.2667rem !important;
    overflow: auto;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .el-form {
    margin-top: 0.2667rem;
  }
  .footer {
    text-align: right;
  }
  .el-dialog__header {
    padding-top: 0.2rem !important;
    .el-dialog__title {
      font-size: 0.48rem;
    }
  }
  .add-btn {
    background: unset;
    width: 2rem;
    min-height: 0.6667rem;
    border-radius: 0.2133rem;
    border: 1px solid var(--address-list-brand);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--address-list-brand);
    font-weight: 400;
    font-size: 0.3733rem;
    color: var(--address-list-brand);
    &.is-disabled {
      cursor: not-allowed;
      color: var(--address-list-muted);
      border-color: var(--address-list-muted);
    }
  }
  .address-list {
    margin-top: 0.1067rem;
    overflow-y: auto;
    flex: 1;
    .address-item {
      cursor: pointer;
      position: relative;
      min-height: 2.4rem;
      border-radius: 0.32rem;
      border: 1px solid var(--address-list-border);
      background: var(--address-list-card-bg);
      margin-top: 0.3733rem;
      padding: 0.48rem 0.5333rem 0 0.48rem;
      &:hover {
        // .handle-box {
        //   visibility: visible !important;
        // }
      }
      .name-area {
        .name {
          font-weight: 600;
          font-size: 0.3733rem;
          color: var(--address-list-primary);
          line-height: 0.5867rem;
          display: block;
        }
        .phone {
          font-weight: 400;
          font-size: 0.3733rem;
          color: var(--address-list-primary);
          line-height: 0.5867rem;
          margin-left: 0;
        }
      }
      .address-area {
        display: flex;
        justify-content: space-between;
        margin-top: 0.2933rem;
        .address {
          font-weight: 400;
          font-size: 0.3733rem;
          color: var(--address-list-primary);
          line-height: 0.5867rem;
          padding-bottom: 0.48rem;
          padding-right: 100px;
        }
        .handle-box {
          position: absolute;
          right: 0.5333rem;
          bottom: 0.4rem;
          display: flex !important;
          visibility: visible;
          img {
            width: 0.64rem;
            height: 0.64rem;
            cursor: pointer;
            &:not(:last-child) {
              margin-right: 0.4rem;
            }
          }
        }
      }
      .default-tag {
        position: absolute;
        top: 0.16rem;
        right: 0.24rem;
        width: 1.8rem;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        background: var(--address-list-brand-soft);
        border-radius: 0.2133rem;
        font-weight: 500;
        font-size: 0.3733rem;
        color: var(--address-list-brand);
      }
    }
    .address-item__selected {
      border-color: rgb(255, 255, 255, 0);
      &::after {
        content: "";
        z-index: -1;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border: 2px solid var(--address-list-brand);
        border-radius: 0.2133rem;
      }
    }
  }
  .tips {
    margin-top: 0.6133rem;
    margin-bottom: 0.3467rem;
    font-weight: 400;
    font-size: 0.3733rem;
    color: var(--address-list-muted);
    line-height: 0.5333rem;
  }
}

.address-list {
  margin-top: 4px;
  // max-height: 400px;
  // overflow-y: auto;
  .address-item {
    cursor: pointer;
    position: relative;
    min-height: 90px;
    border-radius: 12px;
    border: 1px solid var(--address-list-border);
    background: var(--address-list-card-bg);
    margin-top: 14px;
    padding: 18px 20px 0 18px;
    &:hover {
      .handle-box {
        visibility: visible !important;
      }
    }
    .name-area {
      .name {
        font-weight: 600;
        font-size: 14px;
        color: var(--address-list-primary);
        line-height: 22px;
      }
      .phone {
        font-weight: 400;
        font-size: 14px;
        color: var(--address-list-primary);
        line-height: 22px;
        margin-left: 21px;
      }
    }
    .address-area {
      display: flex;
      justify-content: space-between;
      margin-top: 11px;
      .address {
        font-weight: 400;
        font-size: 14px;
        color: var(--address-list-primary);
        line-height: 22px;
        padding-bottom: 18px;
        padding-right: 100px;
      }
      .handle-box {
        position: absolute;
        right: 20px;
        bottom: 15px;
        display: flex !important;
        visibility: hidden;
        img {
          width: 24px;
          height: 24px;
          cursor: pointer;
          &:not(:last-child) {
            margin-right: 15px;
          }
        }
      }
    }
    .default-tag {
      position: absolute;
      top: 6px;
      right: 9px;
      width: 80px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: var(--address-list-brand-soft);
      border-radius: 8px;
      font-weight: 500;
      font-size: 14px;
      color: var(--address-list-brand);
    }
  }
  .address-item__selected {
    border-color: rgb(255, 255, 255, 0);
    &::after {
      content: "";
      z-index: -1;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border: 2px solid var(--address-list-brand);
      border-radius: 8px;
    }
  }
}
.tips {
  margin-top: 23px;
  margin-bottom: 13px;
  font-weight: 400;
  font-size: 14px;
  color: var(--address-list-muted);
  line-height: 20px;
}

html.dark .address-list-dialog ::v-deep,
html[data-theme="dark"] .address-list-dialog ::v-deep {
  .el-dialog {
    --address-list-card-bg: var(--mg-control-bg, var(--input-bg));
    --address-list-border: var(--mg-border-subtle, var(--border-subtle));
    --address-list-primary: var(--mg-text-primary, var(--text-primary));
    --address-list-muted: var(--mg-text-muted, var(--text-muted));
    --address-list-brand: var(--mg-brand-primary, #00c89d);
    --address-list-brand-soft: rgba(0, 200, 157, 0.16);
  }
}
</style>
